import get from 'lodash/get';
import { isNumeric } from '../../../js/app/react/validators';

export const MIN_AGE = 1;
export const AGE_ERROR_MSG = (text = '') => `Please enter a valid age ${text}`;

export const validateAreYouMarried = hasPartner => () => {
  const errors = [];
  if (hasPartner !== true && hasPartner !== false) {
    errors.push('Please select an option');
  }
  return errors;
};

export const validateDoYouHaveChildren = hasChildren => () => {
  const errors = [];

  if (hasChildren !== true && hasChildren !== false) {
    errors.push('Please select an option');
  }

  return errors;
};

export const validateName = name => {
  if (!name || name.length === 0) {
    return ['Please enter a valid name'];
  }
  return [];
};

export const isAgeValid = (age, minAge = MIN_AGE) => {
  return age !== '' && isNumeric(age) && +age >= minAge;
};

export const validateAge = (hasPartner, principalAge, partnerAge) => () => {
  const isPrincipalAgeValid = isAgeValid(principalAge);
  const isPartnerAgeValid = isAgeValid(partnerAge);

  if (hasPartner) {
    return [
      ...(!isPrincipalAgeValid ? [AGE_ERROR_MSG()] : []),
      ...(!isPartnerAgeValid ? [AGE_ERROR_MSG('for your partner')] : []),
    ];
  }

  return [...(!isPrincipalAgeValid ? [AGE_ERROR_MSG()] : [])];
};

export const validateChildAge = age => {
  const minAge = 0;
  const isChildAgeValid = isAgeValid(age, minAge);
  if (!isChildAgeValid) {
    return [AGE_ERROR_MSG()];
  }
  return [];
};

export const validateChild = (name, age) => [...validateName(name), ...validateChildAge(age)];

export const validateSpouseName = (personalInfo, partnerName) => () => {
  const errors = validateName(partnerName);

  if (errors.length === 0 && partnerName === get(personalInfo, 'Principal.FirstName')) {
    errors.push('Please specify a partner first name different from the principal first name.');
  }
  return errors;
};

export const isPersonalInfoValid = (hasPartner, personalInfo) => {
  if (hasPartner) {
    if (validateName(get(personalInfo, 'Partner.FirstName')).length > 0) {
      return false;
    }

    if (get(personalInfo, 'Partner.FirstName') === get(personalInfo, 'Principal.FirstName')) {
      return false;
    }
  }

  if (
    validateAge(hasPartner, get(personalInfo, 'Principal.Age'), get(personalInfo, 'Partner.Age'))()
      .length > 0
  ) {
    return false;
  }

  return true;
};
